/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Agenda_EmptyInputs */



/**
* | output |
* | --- |
* | "Your agenda is empty. Events you play, organize, or that are near you show up here. Browse all events, or subscribe to the calendar feed." |
*
* @param {Tournaments_Agenda_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_agenda_empty = /** @type {((inputs?: Tournaments_Agenda_EmptyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Agenda_EmptyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre agenda est vide. Les tournois auxquels vous jouez, que vous organisez ou qui ont lieu près de chez vous apparaissent ici. Parcourez tous les tournois, ou abonnez-vous au calendrier.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su agenda está vacía. Aquí aparecen los torneos en los que juega, que organiza o que son cerca de usted. Explore todos los torneos o suscríbase al calendario.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sua agenda está vazia. Aqui aparecem os torneios em que você joga, que organiza ou que são perto de você. Veja todos os torneios, ou assine o calendário.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La tua agenda è vuota. Qui compaiono i tornei in cui giochi, che organizzi o vicino a te. Sfoglia tutti i tornei, o iscriviti al calendario.")
	return /** @type {LocalizedString} */ ("Your agenda is empty. Events you play, organize, or that are near you show up here. Browse all events, or subscribe to the calendar feed.")
});